interface MaximizeIconProps {
  fill?: string;
}
const MaximizeIcon = ({ fill }: MaximizeIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.19523 8.8619C6.45558 8.60155 6.87759 8.60155 7.13794 8.8619C7.39829 9.12225 7.39829 9.54426 7.13794 9.80461L3.60929 13.3333H5.99992C6.36811 13.3333 6.66659 13.6317 6.66659 13.9999C6.66659 14.3681 6.36811 14.6666 5.99992 14.6666H1.99992C1.63173 14.6666 1.33325 14.3681 1.33325 13.9999V9.99992C1.33325 9.63173 1.63173 9.33325 1.99992 9.33325C2.36811 9.33325 2.66659 9.63173 2.66659 9.99992V12.3905L6.19523 8.8619ZM14.6666 5.99992C14.6666 6.36811 14.3681 6.66659 13.9999 6.66659C13.6317 6.66659 13.3333 6.36811 13.3333 5.99992V3.60929L9.80461 7.13794C9.54426 7.39829 9.12225 7.39829 8.8619 7.13794C8.60155 6.87759 8.60155 6.45558 8.8619 6.19523L12.3905 2.66659H9.99992C9.63173 2.66659 9.33325 2.36811 9.33325 1.99992C9.33325 1.63173 9.63173 1.33325 9.99992 1.33325H13.9999C14.3681 1.33325 14.6666 1.63173 14.6666 1.99992V5.99992Z"
        fill={fill ?? "#313131"}
      />
    </svg>
  );
};

export default MaximizeIcon;
